import { RootState } from '../redux/store';
import { CalendarCheck } from 'lucide-react';
import { Button } from './Button';
import { resetAppointment } from '../redux/slices/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatSelectedSlot } from '../utils/helpers';

interface SuccessWithoutPollingProps {
  className?: string;
  isSmartBooking?: boolean;
  success: { time: string; patientName: string };
}

// Temporary confirmation card without portal-link polling. Swap back to
// <SuccessCard /> in Confirmation.tsx to re-enable the polling experience.
export const SuccessWithoutPolling = ({ className = '', isSmartBooking, success }: SuccessWithoutPollingProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { practice } = useSelector((s: RootState) => s.auth);
  const isManual = practice?.scheduler_type === 'manual';

  return (
    <div className={`space-y-5 py-2 flex justify-center flex-col items-center ${className}`}>
      <CalendarCheck size={60} className="text-success-700" />
      {isManual ? (
        <div className="text-center space-y-2">
          <div className="text-xl font-semibold text-black">
            Thanks {success.patientName}!
          </div>
          <div className="text-base text-gray-600">
            We've received your request. We'll call you shortly for appointment confirmation.
          </div>
        </div>
      ) : (
        <div className="text-center space-y-2">
          <div className="text-xl font-normal text-black text-center">
            {success.patientName}, we've got you<br />confirmed for your appointment
          </div>
          <div className="text-xl font-bold text-black text-center">{formatSelectedSlot(success.time || '')}</div>
        </div>
      )}
      <div className="flex justify-between">
        <Button
          title={isManual ? 'Request another appointment' : 'Book another appointment'}
          variant='primary'
          onClick={() => {
            dispatch(resetAppointment());
            if (isSmartBooking) {
              navigate(`../smart-booking${location.search || ''}`);
            } else {
              navigate('../step-1');
            }
          }}
        />
      </div>
    </div>
  );
};
